export default {
    state: () => ({
        data: {
            isOpenSmallBasket: true,
            items:[],
            summ:0,
            discount:0,
            actionPath:"",
            coupons:[]
        }
    }),
    mutations: {
        ['basket/setState'](state, payload) {
            state.data = payload;
        },
        ['basket/changeOpenSmallBasket'](state, payload) {
            if(payload) {
                this.dispatch('basket/getOpenSmallBasketInfo', {});
            }

            state.data = { ...state.data, isOpenSmallBasket: payload };
        },
    },
    actions: {
        async ['basket/getOpenSmallBasketInfo']({ state, commit }, payload) {
            let ids = [];
            for(let index in state.data.items) {
                ids.push(state.data.items[index].id);
            }
            await axios.post(state.data.actionPath, {
                handler: 'basket',
                func: 'getOpenSmallBasketInfo',
                ids:ids
            }).then(({ status, data: responseData }) => {
                if(responseData.data.gtmEcommerce) {
                    BX.Aniart.Ecommerce.init().pushEvent(responseData.data.gtmEcommerce);
                }
            });
        },
        async ['basket/add']({ state: { data }, commit, getters }, { id, quantity = 1}) {
            try {
                // const { path, 'params-example-data': params } = data.routes.add;
                const path = data.actionPath;
                const requestParams = {
                    func: 'add',
                    offer: id,
                    handler: "basket",
                    quantity,
                };

                const { status, data: responseData } = await axios.post(path, requestParams);
                if (status !== 200) {
                    throw `add to basket bad response status ${status}`
                }

                if (responseData?.data?.gtm_script) {
                    $('body').append($(responseData.data.gtm_script));
                }
                if (responseData?.data?.webtraking_script) {
                    $('body').append($(responseData.data.webtraking_script));
                }
                if (responseData?.data?.basket) {
                    commit('basket/setState', responseData.data.basket);
                }
            } catch (err) {
                console.error(err);
            }
        },
        async ['basket/remove']({ state: { data }, commit, dispatch, rootState }, payload) {
            try {
                const requestParams = {
                    id: payload,
                    handler: "basket",
                    func: "delete"
                };
                const { status, data: responseData } = await axios.post(data.actionPath, requestParams);
                if (status !== 200 || responseData.error) {
                    throw `Bad request delete product from basket status: ${ status } \n ${ responseData.error }`;
                }

                if (responseData?.data?.gtm_script) {
                    $('body').append($(responseData.data.gtm_script));
                }
                if (responseData?.data?.webtraking_script) {
                    $('body').append($(responseData.data.webtraking_script));
                }
                commit('basket/setState', responseData.data.basket);

                commit('basket/changeOpenSmallBasket', !!responseData.data.basket.items.length);
            } catch (err) {
                console.error(err);
            }
        },
        async ['basket/update']({ state: { data }, commit, dispatch, rootState }, { id, count = 1}) {
            try {
                const path = data.actionPath;
                const requestParams = {
                    handler: "basket",
                    func: 'update',
                    id: id,
                    quantity: count,
                };

                const { status, data: responseData } = await axios.post(path, requestParams);
                if (status !== 200) {
                    throw `add to basket bad response status ${status}`
                }

                commit('basket/setState', responseData.data.basket);
            } catch (err) {
                console.error(err);
            }
        },
        async ['basket/createOrderByOneClick']({ state: { data }, dispatch }, requestParams) {
            try {
                const { path, 'params-example-data': params } = data?.routes?.buyOneClick;

                const ajaxParams = {...requestParams, action: params.action, LANGUAGE_ID : params.LANGUAGE_ID};

                const { status, data: responseData } = await axios.post(path, ajaxParams);
                if (status !== 200) {
                    throw `create order one click bad response status ${status}`
                }
                await dispatch('basket/getData');

                return responseData;

            } catch (err) {
                console.error(err);
            }
        },
        async ['basket/getData']({ state, commit }) {
            const { path, action } = state.data.routes?.getBasket;
            const { status, data } = await axios.post(path, { action });

            if (status === 200) {
                commit('basket/setState', data);
            }
        },
        async ['basket/setCoupon']({ state, commit }, payload) {
            commit('global/loaderStart');
            const { path, 'params-example-data': { action } } = state.data.routes?.setCoupon;
            const props = {
                coupon: payload,
                action,
            }

            const { data } = await axios.post(path, props);
            commit('basket/setState', data);

            commit('global/loaderStop');
            return data;
        },
        async ['basket/deleteCoupon']({ state, commit }, payload) {
            commit('global/loaderStart');
            const { path, 'params-example-data': { action } } = state.data.routes?.delCoupon;
            const props = {
                coupon: payload,
                action,
            }

            const { data } = await axios.post(path, props);
            commit('basket/setState', data);
            commit('global/loaderStop');
            return data;
        },
        async ['basket/setCertificate']({ state, commit }, payload) {
            try {
                commit('global/loaderStart');
                const { path, 'params-example-data': { action } } = state.data.routes?.setCertificate;
                const props = {
                    certificate: payload,
                    action,
                }

                const { data, status } = await axios.post(path, props);

                if (status !== 200) {
                    throw `Something went wrong status ${ status }`;
                } else if (!data.error) {
                    commit('basket/setState', data);
                }

                return data;
            } catch (err) {
                console.error(err);
            } finally {
                commit('global/loaderStop');
            }
        },
        async ['basket/deleteCertificate']({ state, commit }, payload) {
            try {
                commit('global/loaderStart');

                const { path, 'params-example-data': { action } } = state.data.routes?.delCertificate;
                const props = {
                    certificate: payload,
                    action,
                }

                const { data, status } = await axios.post(path, props);

                if (status !== 200) {
                    throw `Something went wrong status ${ status }`;
                }

                commit('basket/setState', data);

            } catch (err) {
                console.error(err);
            } finally {
                commit('global/loaderStop');
            }
        }
    },
    getters: {
        ['basket/inBasket']: ({ data: { items } }) => id => {
            try {
                if (Array.isArray(items)) {
                    return !!items.find(el => el?.offer?.id == id ?? el?.id == id);
                } else {
                    return false;
                }
            } catch (err) {
                console.error(err);
                return false;
            }
        },
        ['basket/getProductById']: ({ data: { items } }) => id => {
            try {
                if (Array.isArray(items)) {
                    return items.find(el => el.id == id);
                } else {
                    return false;
                }
            } catch (err) {
                console.error(err);
                return false;
            }
        },

    }
}